import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { ChangeLogEntry } from '../../entities/ChangeLog/ChangeLog'

export type ChangeLogEntryState = AsyncReduxState<{
    changeLogEntry?: ChangeLogEntry
}>

const initialState: ChangeLogEntryState = {
    ...initialAsyncReduxState,
}

export const changeLogEntrySlice = createSlice({
    name: 'changeLogEntryReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ChangeLogEntryState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ChangeLogEntryState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ChangeLogEntryState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setChangeLogEntry(state, action: PayloadAction<ChangeLogEntry>): ChangeLogEntryState {
            return {
                ...state,
                changeLogEntry: action.payload,
            }
        },
        setChangeLogEntryToExistingChangeLogEntries(state, action: PayloadAction<ChangeLogEntry>): ChangeLogEntryState {
            return {
                ...state,
                changeLogEntry: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setError,
    setIsSuccessful,
    setChangeLogEntry,
    setChangeLogEntryToExistingChangeLogEntries,
} = changeLogEntrySlice.actions

export const changeLogEntryReducer = changeLogEntrySlice.reducer
